import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup, { useRadioGroup } from '@mui/material/RadioGroup';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Infos from "../../constants/Infos";
import { LEGAL_MENU_TYPES } from "../../enums/Enums";
import { commonActions } from "../../redux/reducers/CommonReducer";
import store from "../../redux/Store";
import Colors from "../../resources/Colors";
import Fonts from "../../resources/fonts/Fonts";
import classes from "./LegalPage.module.css";

const StyledFormControlLabel = styled((props) => <FormControlLabel style={{ marginBottom: '25px', color: Colors.DARK_GREY }} {...props} />)(
    ({ theme, checked }) => ({
        '.MuiFormControlLabel-label': checked && {
            color: Colors.URTON_MAIN_COLOR
        },
    }),
);

const MyFormControlLabel = (props) => {
    const radioGroup = useRadioGroup();

    let checked = false;

    if (radioGroup) {
        checked = radioGroup.value === props.value;
    }

    return <StyledFormControlLabel checked={checked} {...props} />;
};

const LegalPage = () => {
    const [legalMenuValue, setLegalMenuValue] = useState(LEGAL_MENU_TYPES.TERMS_OF_USE);

    const currentUsersScopes = useSelector((state) => {
        return state.user?.currentUsersScopes;
    });

    useEffect(() => {
        if (currentUsersScopes?.length > 0) {
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }

    }, [currentUsersScopes]);

    const getLegalTypeDescriptionContent = () => {
        switch (legalMenuValue) {
            case LEGAL_MENU_TYPES.TERMS_OF_USE:
                return Infos.TERMS_OF_USE_INFO;
            case LEGAL_MENU_TYPES.PRIVACY_POLICY:
                return Infos.PRIVACY_POLICY_INFO;
            default:
                return '';
        };
    }

    return (
        <div className={classes.LegalPage}>
            <div className={classes.RadioGroupForm}>
                <div>
                    <RadioGroup
                        name="use-radio-group"
                        value={legalMenuValue}
                        onChange={(event) => setLegalMenuValue(event.target.value)}
                        className={classes.RadioGroup}
                    >
                        <MyFormControlLabel
                            value={LEGAL_MENU_TYPES.TERMS_OF_USE}
                            label={
                                <span
                                    style={{ fontSize: '20px', fontFamily: Fonts.ROBOTO_BOLD }}>
                                    {LEGAL_MENU_TYPES.TERMS_OF_USE}
                                </span>
                            }
                            control={
                                <Radio
                                    style={{ color: Colors.GREY }}
                                />
                            }
                        />
                        <MyFormControlLabel
                            value={LEGAL_MENU_TYPES.PRIVACY_POLICY}
                            label={
                                <span
                                    style={{ fontSize: '20px', fontFamily: Fonts.ROBOTO_BOLD }}>
                                    {LEGAL_MENU_TYPES.PRIVACY_POLICY}
                                </span>
                            }
                            control={
                                <Radio
                                    style={{ color: Colors.GREY }}
                                />
                            }
                        />
                    </RadioGroup>
                </div>
            </div>
            <div className={classes.DescriptionForm}>
                <div>
                    <div className={classes.LegalTypeHeaderContent}>{legalMenuValue}</div>
                </div>
                <div className={classes.LegalTypeDescriptionContainer}>
                    <div className={classes.LegalTypeDescriptionContent}>{getLegalTypeDescriptionContent()}</div>
                </div>
            </div>
        </div>
    );
};

export default LegalPage;
